import script from "./edit-article.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-article.vue?vue&type=script&setup=true&lang=js"

import "./edit-article.vue?vue&type=style&index=0&id=7311a8d7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\dashboard-pro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7311a8d7"]])

export default __exports__